import cn from 'classnames';

import { TooltipActionsWrapper } from 'components/TooltipActionsWrapper';

interface CardDetail {
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  date?: string;
  title: React.ReactNode;
}

export function CardDetail({
  actions,
  children,
  className,
  date,
  title,
}: CardDetail) {
  return (
    <TooltipActionsWrapper
      actions={actions}
      className={cn(
        'flex flex-col gap-y-2.5 rounded-[8px] bg-gray-50 p-4',
        className,
      )}
    >
      <div className="flex justify-between">
        <span className="text-heading-25 text-gray-600">{title}</span>
        {date && <span className="text-12/100% text-gray-600">{date}</span>}
      </div>
      <div className="flex flex-col text-14/120% font-medium text-gray-800">
        {children}
      </div>
    </TooltipActionsWrapper>
  );
}
